const userAssignedSite = 'userAssignedSite';

/**
 * Removes all user data via the Web Storage API. The type of storage used is dependent on the sign-in preferences
 *
 * @param {boolean} isLocal Whether to clear `localStorage` or `sessionStorage`
 */
export function clearCurrentUserData(isLocal) {
  if (isLocal) {
    localStorage.clear();
  } else {
    sessionStorage.clear();
  }
}

/**
 * (not used) Fetches the user-assigned site via the Web Storage API. The type of storage used is dependent on the sign-in preferences
 *
 * @param {boolean} isLocal The type of storage to fetch from
 * @returns {string} The user-assigned site, or an empty string if the key does not exist
 */
export function getUserAssignedSite(isLocal) {
  if (isLocal) {
    return localStorage.getItem(userAssignedSite) ?? '';
  }
  return sessionStorage.getItem(userAssignedSite) ?? '';
}

/**
 * (not used) Saves the user-assigned site via the Web Storage API. The type of storage used is dependent on the sign-in preferences
 *
 * @param {boolean} isLocal Whether to use `localStorage` or `sessionStorage`
 * @param {string} siteName The name of the assigned site
 */
export function setUserAssignedSite(isLocal, siteName) {
  if (isLocal) {
    localStorage.setItem(userAssignedSite, siteName);
  } else {
    sessionStorage.setItem(userAssignedSite, siteName);
  }
}
